/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Search_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "No conversation matches this search." |
*
* @param {Conversations_Search_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_search_empty_body = /** @type {((inputs?: Conversations_Search_Empty_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Search_Empty_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er is geen gesprek dat aan deze zoekopdracht voldoet.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune conversation ne correspond à cette recherche.")
	return /** @type {LocalizedString} */ ("No conversation matches this search.")
});